var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-list-item",class:{
    'feature-list-item--small': _vm.small && !_vm.plain,
    'feature-list-item--plain': _vm.plain,
  }},[(!_vm.plain)?_c('AppIcon',{staticClass:"feature-list-item__icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e(),_c('TextWrapper',{staticClass:"feature-list-item__text",attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }